import { useQuery } from '@tanstack/react-query';
import { PatientDetailsResponse } from '@web-app/graphql/healthie/queries/get-client-details/types';
import { PATIENT_DETAILS_QUERY_KEY } from '@web-app/hooks/consts';

export const useGetPatientDetails = (id: string) => {
  return useQuery<PatientDetailsResponse>({
    queryKey: [PATIENT_DETAILS_QUERY_KEY, id],
    queryFn: async () => {
      try {
        const response = await fetch(`/api/healthie/client/${id}`, {
          headers: {
            'Cache-Control': 'no-cache',
          },
        });
        if (!response.ok) {
          console.error('[CLIENT_PROFILE] - API Error:', {
            status: response.status,
            statusText: response.statusText,
            clientId: id ? 'PROVIDED' : 'MISSING',
          });
          throw new Error('Failed to fetch client details');
        }
        const result = await response.json();
        if (result.errors) {
          console.error('[CLIENT_PROFILE] - GraphQL Error occurred:', {
            errorCount: result.errors.length,
            firstErrorType: result.errors[0]?.extensions?.code || 'UNKNOWN',
          });
          throw new Error(
            result.errors[0]?.message || 'Failed to fetch client details',
          );
        }
        return result;
      } catch (error) {
        console.error('[CLIENT_PROFILE] - Error fetching client details:', {
          errorType:
            error instanceof Error ? error.constructor.name : 'Unknown',
          hasClientId: !!id,
        });
        throw error;
      }
    },
    staleTime: 30000, // 30 seconds
    gcTime: 60000, // 1 minute
    enabled: !!id,
  });
};
